import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

export default function RenderFooter({ handleClose, handleSubmit, loading, isEdit }) {
    const [t] = useTranslation("common");
    const maintheme = useSelector((state) => state.themeData.maintheme);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                justifyContent: "flex-end",
                width: "100%"
            }}
        >
            <Button
                variant="outlined"
                onClick={handleClose}
                sx={{
                    fontFamily: "Cairo-Medium",
                    borderColor: maintheme?.primary,
                    color: maintheme?.primary,
                    px: 4,
                    "&:hover": {
                        borderColor: maintheme?.secondary,
                        backgroundColor: "transparent"
                    }
                }}
            >
                {t("GLOBAL.action_cancel") || "إلغاء"}
            </Button>
            <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
                sx={{
                    fontFamily: "Cairo-Medium",
                    backgroundColor: maintheme?.primary,
                    px: 4,
                    "&:hover": {
                        backgroundColor: maintheme?.secondary,
                    },
                }}
            >
                {loading ? (
                    <CircularProgress size={24} color="inherit" />
                ) : isEdit ? (
                    t("GLOBAL.action_update") || "تحديث"
                ) : (
                    t("GLOBAL.action_save") || "حفظ"
                )}
            </Button>
        </Box>
    );
}
